// extracted by mini-css-extract-plugin
module.exports = {"text":"WeatherCopyright_text__12CRJ","highlighted":"WeatherCopyright_highlighted__2zMVH"};